import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SSNInput from './SSNInput';

function SSNInputDemo() {
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>Text Input</h4>
            <Container className="d-flex justify-content-between flex-wrap p-0">
              <SSNInput label={'Sample label'} />
              <SSNInput label={'Sample label'} />
              <SSNInput label={'Sample label'} disabled />
              <SSNInput label={'Sample label'} isValid={true} />
              <SSNInput label={'Sample label'} isInvalid={true} />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default SSNInputDemo;
